export default __webpack_public_path__ + "static/shanly-logo-new-eb4ffa6a20e00ee7703c28a5dfa86c24.png";